import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Table,
  Card,
  CardBody,
} from "reactstrap"
import CardItem from "./CardItem"
import "./Style.scss"
import Paginator from "components/Common/Paginator/Paginator"
import FilterForm from "./FilterForm"
import FilterIcon from "assets/images/filter.png"
import { useDispatch, useSelector } from "react-redux"
import { appendFilters } from "store/actions"
import DeveloperService from "services/Provider/DeveloperService"

const DeveloperPage = (props) => {
  const developerService = new DeveloperService()
  const [showFilters, setShowFilters] = useState(false)
  const [filtersParams, setFilterParams] = useState(null)
  const [shouldGetData, setShouldGetData] = useState(false)
  const [active, setActive] = useState("all")
  const [searchWord, setSearchWord] = useState("")
  const [list, setList] = useState([])
  const [countryId, setCountryId] = useState(null)
  const [locationId, setLocationId] = useState(null)
  const [exportUrl, setExportUrl] = useState("")
  const AuthData = useSelector(state => state.Auth)
  const filterData = useSelector(state => state.adminFilter)
  const isExist = (data) => AuthData.permissions.includes(data)
  const dispatch = useDispatch()
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 10,
    totalSize: 1,
  })

  // const updateHandler = (id) => {
  //   props.history.push(`${adminPrefix}/developer-update/${id}`)
  // }

  const OnSearchChange = (e) => {
    const search = e.target.value
    setSearchWord(search)
  }

  useEffect(() => {
    if(!!filterData?.country?.label){
      setCountryId(filterData?.country)
    }
    if(filterData?.location?.length > 0){
      setLocationId([...filterData?.location])
    }
    
  },[])
  
  useEffect(() => {
    dispatch(appendFilters({
      developer_id: null
    }))
    // debounce solution to reduce request data from api
    const timeoutId = setTimeout(() => {
      const params = {}
      if (active != 'all') params['status'] = active === "active" ? 1 : 0
      if (searchWord.trim().length) params['keyword'] = searchWord
      if (!!countryId?.value) params['country'] = countryId?.value //?.map(admin => admin.value).join()
      if (locationId ?.length !== 0) params['area_ids'] = locationId ?.map(loc => loc?.value).join()

      setFilterParams({ ...params })
      dispatch(appendFilters({
        country: countryId,
        location: locationId,
        area_ids: params['location']
      }))

    }, 1000)
    return () => clearTimeout(timeoutId)
  }, [active, searchWord,countryId, locationId])

  useEffect(() => {
    const url = developerService.getExportUrl(active, searchWord, locationId)
    setExportUrl(url)
  }, [active, searchWord, locationId])

  return (
    <React.Fragment>
      <div className='page-content'>
        <MetaTags>
          <title>Developer</title>
        </MetaTags>
        <Container fluid>
          <Row className="mb-1">
            <Col md={6}>
              <h4>Manage Developers</h4>
              <p>You can manage All Developers in Meras System</p>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  value={searchWord}
                  onChange={(e) => OnSearchChange(e)}
                  placeholder="Search by developer name, I.D" />
              </div>
            </Col>
            <Col md={6}>
              <div className="d-md-flex justify-content-md-end mb-2">
                <button
                  className="btn btnUpload btnHeight btnHeight px-lg-4 me-2"
                  onClick={() => window.open(exportUrl)}

                 >
                     Export Excel Sheet
                 </button>
              </div>
            </Col>

          </Row>
          <Row className="mb-4" >
            <Col md={6} sm={8} className="mb-3">
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "all" ? "#556ee6" : "#f4f4f4",
                  color: active == "all" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("all")
                }}
              >
                All
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "active" ? "#556ee6" : "#f4f4f4",
                  color: active == "active" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("active")
                }}
              >
                Active
                            </button>
              <button
                className="btn btnHeight me-2 px-4"
                style={{
                  background: active == "deactive" ? "#556ee6" : "#f4f4f4",
                  color: active == "deactive" ? "#FFF" : "#495057"
                }}
                onClick={() => {
                  setActive("deactive")
                }}
              >
                Deactive
                            </button>
            </Col>
            <Col md={6} sm={4} className="mb-3 d-flex flex-row-reverse">

              <button className="btn btnUpload btnHeight px-4" style={{ margin: "0" }} onClick={() => {
                setShowFilters(!showFilters)
              }}><img src={FilterIcon} style={{ marginRight: "5px" }} />Filter</button>
            </Col>
          </Row>
          {showFilters ? <FilterForm
            showFilters={showFilters}
            setCountryId={setCountryId}
            countryId={countryId}
            setLocationId={setLocationId}
            locationId={locationId}
            // filteredData={}
            setShowFilters={setShowFilters}
          /> : null}
          <div>
            <Card className="w-100 mt-4">
              <CardBody>
                <div className='py-3'>
                  <div>
                    <div className="table-responsive">
                      <Table>
                        <thead>
                          <tr className='bgHeaderTable'>
                            <th className='font-size-14'>I.D</th>
                            <th className='font-size-14'>Developer Name</th>
                            <th className='font-size-14'>Compounds</th>
                            <th className='font-size-14'>Available Units</th>
                            <th className='font-size-14'>Location</th>
                            <th className='font-size-14'>Status</th>
                            {/* <th className='font-size-14'></th> */}
                          </tr>
                        </thead>
                        <tbody>

                          {list.map((item, index) => <CardItem
                            key={index}
                            index={index}
                            {...item}
                            item={item}
                            Service={DeveloperService}
                            setShouldGetData={setShouldGetData}
                          />)}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
            <Row className="d-flex justify-content-end">
              <Col className="d-flex justify-content-end" md={8} sm={12}>
                <Paginator
                  service={developerService}
                  pageOptions={pageOptions}
                  setData={(data) => setList([...data])}
                  setPageOptions={setPageOptions}
                  filtersParams={filtersParams}
                  shouldGetData={shouldGetData}
                  setShouldGetData={setShouldGetData}
                />
              </Col>
            </Row >
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DeveloperPage